import { useEffect } from "react"
import { Container } from "./Container"
import { Nav } from "./Nav"
import { methodHandelCheckUserFields } from "utils/layout-utils"
import { LayoutStore } from "store/layout-store"
import { CNotification } from "components/widget/CNotification"

export const BaseLayout = ({ children }: any) => {
    const { userId, setCurrentUserFields  } = LayoutStore()


    useEffect(() => {
        methodHandelCheckUserFields(userId, setCurrentUserFields)
    }, [userId])

    return (
        <>
            <div className="flex justify-end w-full bg-trade-50 ">
                <Container >
                    {children}
                </Container>
                <Nav />
            </div>
        </>
    )
}